import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
//import { Accordion, AccordionItem } from '@tmhcc-ng-lib/framwork/models';
//import { Types } from '@tmhcc-ng-lib/framwork/grid';
import {
  StepResponse,
  AppDataService,
  StepsService,
  Coverage,
  StepRequest,
  GlobalVariablesService
} from '@tmhcc-ng-lib/data-service';
import { has } from '@tmhcc/util';
import { StepNevigationService } from '../nevigation/step-nevigation.service';
import { Status } from '@tmhcc-ng-lib/models';

export class BasePendingCoverageComponent {
  public coverages: StepResponse;
  public siteCoreData;
  public finalCoverage: Coverage[];
  public imgSrc = [];
  constructor(
    protected loaderService: LoaderService,
    protected appDataService: AppDataService,
    protected stepsService: StepsService,
    protected globalVariables: GlobalVariablesService,
    protected stepNevigationService: StepNevigationService
  ) {}

  showAccordion = {
    accordion0: false,
    accordion1: false,
    accordion2: false
  };

  getNgOnInit() {
    this.appDataService.showSummary.next(true);
    this.appDataService.stepsSitecoreContent.next();
    this.appDataService.summarySitecoreContent.next();
    this.appDataService.getStepsSitecoreData().subscribe(res => {
      this.loaderService.show();
      if (res) {
        this.siteCoreData = res;
      }
    });
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.appDataService.fetchAndPublishPolicyDetails(payload);
    this.appDataService.getPolicyDetails().subscribe(res => {
      if (res) {
        // if (
        //   res.SummaryDetails.SummaryPendingItem.PolicyStatus !=
        //   Status.PendingReview
        // ) {
        //   this.stepNevigationService.stepNevigation(res, true);
        // }
        this.getCoveragesData(res);
        this.coverageImg(res, this.siteCoreData);
      }
    });
  }

  getCoveragesData(data: StepResponse) {
    let defaultCoverages: Coverage[] = [
      {
        Name: 'General Liability',
        Description: 'Not Quoted',
        SubHeading: 'Not Quoted'
      },
      {
        Name: 'Excess Liability',
        Description: 'Not Quoted',
        SubHeading: 'Not Quoted'
      },
      {
        Name: 'Contractors Personal Property',
        Description: 'Not Quoted',
        SubHeading: 'Not Quoted'
      }
    ];

    this.finalCoverage = [];

    defaultCoverages.forEach(_coverage => {
      if (has(data, 'Coverages') && data.Coverages.length > 0) {
        let resultItem = data.Coverages.find(
          coverage =>
            coverage.Name.toLowerCase() === _coverage.Name.toLowerCase()
        );
        if (!resultItem) {
          _coverage.SubHeading = _coverage.Description;
          this.finalCoverage.push(_coverage);
        } else {
          resultItem.SubHeading = resultItem.Description;
          this.finalCoverage.push(resultItem);
        }
      }
    });
    data.Coverages = this.finalCoverage;

    this.coverages = data;
    setTimeout(() => {
      this.loaderService.hide();
    }, 300);
  }

  changeToNotQuoted(item, showHideText, tabName) {
    this.finalCoverage = [...this.finalCoverage].map(item => {
      item.SubHeading = item.Description;
      if (item.Name.toLowerCase() === 'contractors personal property') {
        if (
          item.Description.match('Starting at') &&
          tabName.toLowerCase() === 'contractors personal property'
        ) {
          item.SubHeading = showHideText ? 'Not Quoted' : item.Description;
        }
      }
      if (item.Name.toLowerCase() === 'excess liability') {
        if (
          item.Description.match('Starting at') &&
          tabName.toLowerCase() === 'excess liability'
        ) {
          item.SubHeading = showHideText ? 'Not Quoted' : item.Description;
        }
      }
      return item;
    });
  }

  hideAllAccordion(index) {
    this.coverages.Coverages.forEach((item, i) => {
      if (index !== i) {
        this.showAccordion['accordion' + i] = false;
      }
    });
  }

  coverageImg(policyData, siteCoreData) {
    policyData.Coverages.forEach(item => {
      if (has(siteCoreData, 'sidemenu') && siteCoreData.sidemenu.length > 0) {
        let resultItem = siteCoreData.sidemenu[1].submenu.find(
          coverage =>
            coverage.image.Alt.toLowerCase() === item.Name.toLowerCase()
        );
        if (resultItem) {
          this.imgSrc.push(resultItem.image.Src);
        }
      }
    });
  }
}
